module.exports = __webpack_public_path__ + "img/circles.8c589ee0.svg";